import React, { useState, useEffect } from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import "antd/dist/reset.css";
import "./index.css";
import { HashRouter, BrowserRouter } from "react-router";
import { loadConfig } from "./config";

// Config yüklendikten sonra uygulamayı başlat
const root = ReactDOM.createRoot(document.getElementById("root"));

const RootApp = () => {
    const [configLoaded, setConfigLoaded] = useState(false);

    useEffect(() => {
        loadConfig().then(() => {
            setConfigLoaded(true);
        });
    }, []);

    if (!configLoaded) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh'
            }}>
                Yükleniyor...
            </div>
        );
    }

    return (
        <React.StrictMode>
            <HashRouter>
                <App />
            </HashRouter>
        </React.StrictMode>
    );
};

root.render(<RootApp />);
